
import { Award, Clock, DollarSign, BarChart4, PiggyBank, Compass } from 'lucide-react';

const BookInsightsSection = () => {
  const insights = [
    {
      icon: <DollarSign className="h-8 w-8 text-white" />,
      title: "Double Your Income",
      description: "Learn proven strategies to command premium rates and increase your consulting income.",
    },
    {
      icon: <Clock className="h-8 w-8 text-white" />,
      title: "Work Half the Year",
      description: "Discover how to structure your consulting business for maximum efficiency and work-life balance.",
    },
    {
      icon: <Award className="h-8 w-8 text-white" />,
      title: "Build Your Authority",
      description: "Position yourself as the go-to expert in your field and attract high-value clients.",
    },
    {
      icon: <BarChart4 className="h-8 w-8 text-white" />,
      title: "Scale Your Business",
      description: "Implement systems to grow beyond trading time for money and build a sustainable consulting practice.",
    },
    {
      icon: <PiggyBank className="h-8 w-8 text-white" />,
      title: "Tax Optimization",
      description: "Learn legal strategies to minimize your tax burden as an independent consultant.",
    },
    {
      icon: <Compass className="h-8 w-8 text-white" />,
      title: "Find Your Freedom",
      description: "Create the lifestyle you want with location independence and time autonomy.",
    }
  ];

  return (
    <section className="gradient-section">
      <div className="container mx-auto px-4">
        <h2 className="section-title">
          Here's A Sneak Peek At Some Of The Insights<br className="hidden md:block" />
          And Strategies You'll Find Inside The Book:
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {insights.map((insight, index) => (
            <div 
              key={index} 
              className="bg-book-blue p-6 rounded-lg border border-amber-600/30 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="mb-4">
                {insight.icon}
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{insight.title}</h3>
              <p className="text-white/90 text-sm">{insight.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BookInsightsSection;
